import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import WorkingTimeState, {WorkingTimeList} from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<WorkingTimeState> = {
  [mutationType.GET_LISTS](
    state: WorkingTimeState,
    data: WorkingTimeList,
  ): void {
    state.list = data
  },
  [mutationType.CREATE](
    state: WorkingTimeState,
    data: object,
  ): void {
    state.create = data
  },
  [mutationType.UPDATE](
    state: WorkingTimeState,
    data: object,
  ): void {
    state.update = data
  },
  [mutationType.DELETE](
    state: WorkingTimeState,
    data: object,
  ): void {
    state.delete = data
  },
}

export default mutations
